import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { Route } from 'react-router';
import { RibbonActions } from './components';
import { IntegrationAdd, IntegrationConfigure, IntegrationDetails, IntegrationList } from './views';
import { Page } from '@vromo/ui';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../stores/RootStore';
import { useIntegrationsActions, useIntegrationsPage } from './hooks';
import { IntegrationsPageRoute } from '.';



const IntegrationsPage = observer(() => {

    const {
        authStore: { role: { group }, status: { group: AccountGroup } }
    } = useStore<RootStore>('rootStore')
    const { restartContext } = useIntegrationsActions()
    const { isLoading } = useIntegrationsPage()

    useEffect(() => {
        // todo: cancel data fetch is page is changed
        restartContext()
    }, [group, AccountGroup])


    
    return (
        <>
            <Route
                path={IntegrationsPageRoute.configure}
                exact
                component={IntegrationConfigure}
            />
            <Route
                path={IntegrationsPageRoute.add}
                exact
                component={IntegrationAdd}
            />
            <Route
                path={IntegrationsPageRoute.details}
                exact
                component={IntegrationDetails}
            />


            <Page
                isLoading={isLoading}
                title=' integrations'
                TopRightPlaceholder={RibbonActions}
            >
                <IntegrationList />
            </Page>
        </>
    );
});

export default IntegrationsPage 